/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevertApproveDto
 */
export interface RevertApproveDto {
    /**
     * 
     * @type {string}
     * @memberof RevertApproveDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RevertApproveDto
     */
    reason: string;
}

export function RevertApproveDtoFromJSON(json: any): RevertApproveDto {
    return RevertApproveDtoFromJSONTyped(json, false);
}

export function RevertApproveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertApproveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reason': json['reason'],
    };
}

export function RevertApproveDtoToJSON(value?: RevertApproveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reason': value.reason,
    };
}


